import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../_actions';

class RegisterPage2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
                // firstName: '',
                // lastName: '',
                username: '',
                password: ''
            },
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { name } = event.target;
        const { user } = this.state;
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({ submitted: true });
        const { user } = this.state;
        const { dispatch } = this.props;
        if (user.username && user.password && user.password2 && (user.password2 == user.password)) {
            dispatch(userActions.register2(user));
        }
    }

    render() {
        const { registering  } = this.props;
        const { user, submitted } = this.state;
        return (
            <div className="login col-md-6 col-md-offset-3">
                <h2 className="heading">Register</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !user.username ? ' has-error' : '')}>
                        <div className="columns">
                            <div className="column column-1-2">
                                <label htmlFor="username">Username</label>
                            </div>
                            <div className="column column-1-2">
                                <input type="text" className="form-control" name="username" value={user.username} onChange={this.handleChange} />
                                {submitted && !user.username &&
                                    <div className="help-block">Username is required</div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={'form-group' + (submitted && (user.password.length < 8) ? ' has-error' : '')}>
                        <div className="columns">
                            <div className="column column-1-2">                    
                                <label htmlFor="password">New Password</label>
                                </div>
                            <div className="column column-1-2">                            
                                <input type="password" className="form-control" name="password" value={user.password} onChange={this.handleChange} />
                                {submitted && (user.password.length < 8) &&
                                    <div className="help-block">Password minimum length 8 is required</div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={'form-group' + (submitted && (user.password2 != user.password) ? ' has-error' : '')}>
                        <div className="columns">
                            <div className="column column-1-2">                    
                                <label htmlFor="password">Confirm PW</label>
                                </div>
                            <div className="column column-1-2">                            
                                <input type="password" className="form-control" name="password2" value={user.password2} onChange={this.handleChange} />
                                {submitted && user.password && (user.password2 != user.password) &&
                                    <div className="help-block">Passwords are Not Equal</div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="columns">
                            <div className="column column-1-2">                    
                                <label htmlFor="isAdmin">IsAdmin</label>
                                </div>
                            <div className="column column-1-2">                            
                                <input type="checkbox" className="form-control" name="isAdmin" value={user.isAdmin} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>                    

                    <div className="form-group">
                        <button className="btn btn-primary">Register</button>
                        {registering && 
                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                        <Link to="/results" className="btn btn-link">Cancel</Link> 
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { registering } = state.registration;
    return {
        registering
    };
}

const connectedRegisterPage = connect(mapStateToProps)(RegisterPage2);
export { connectedRegisterPage as RegisterPage2 };
